module.exports = __webpack_public_path__ + "img/1725851430423-1723422979192-WhatsApp Image 2024-08-12 at 08.31.39.jpeg.webp.dde3c725.webp";